"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __param = (this && this.__param) || function (paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
};
var _a, _b;
Object.defineProperty(exports, "__esModule", { value: true });
exports.CostReports = void 0;
const T = __importStar(require("@microsoft/fast-element"));
const fast_element_1 = require("@microsoft/fast-element");
require("./template.html");
const client_1 = require("@rws-framework/client");
const backendImport_1 = require("@front/backendImport");
const console_1 = require("@rws-framework/console");
const chart_js_1 = require("chart.js");
const component_1 = require("@front/layouts/default-layout/component");
const component_2 = require("@front/components/site-menu/component");
const StorageService_1 = __importStar(require("@front/services/StorageService"));
chart_js_1.Chart.register(...chart_js_1.registerables);
//@ts-ignore                
let rwsTemplate = T.html `<div class="cost-reports">
    ${(0, fast_element_1.when)(x => !x.hasAccess, (0, fast_element_1.html) `
        <div class="alert alert-danger" role="alert">
            <h4 class="alert-heading">${'reports.access.denied.title'.t()}</h4>
            <p class="mb-0">${x => x.accessDeniedMessage}</p>
        </div>
    `)}
    
    ${(0, fast_element_1.when)(x => x.hasAccess, (0, fast_element_1.html) `
        <div class="page-header">
            <h2>${'reports.costReports.title'.t()}</h2>
            <p class="text-muted">${'reports.costReports.description'.t()}</p>
        </div>

    <div class="card filters-card">
        <div class="card-header">
            <h5 class="mb-0">${'reports.filters'.t()}</h5>
        </div>
        <div class="card-body">
            <div class="row">
                <div class="col-md-2">
                    <label class="form-label">${'reports.startDate'.t()}</label>
                    <input 
                        type="date" 
                        class="form-control" 
                        :value="${x => x.startDate}"
                        @input="${(x, c) => x.startDate = c.event.target.value}"
                    />
                </div>
                <div class="col-md-2">
                    <label class="form-label">${'reports.endDate'.t()}</label>
                    <input 
                        type="date" 
                        class="form-control" 
                        :value="${x => x.endDate}"
                        @input="${(x, c) => x.endDate = c.event.target.value}"
                    />
                </div>
                <div class="col-md-2">
                    <label class="form-label">${'reports.userName'.t()}</label>
                    <input 
                        type="text" 
                        class="form-control" 
                        :value="${x => x.userName}"
                        @input="${(x, c) => x.handleSearchInput('userName', c.event.target.value)}"
                        placeholder="${'reports.userNamePlaceholder'.t()}"
                    />
                </div>
                <div class="col-md-2">
                    <label class="form-label">${'avatar.avatar'.t()}</label>
                    <input 
                        type="text" 
                        class="form-control" 
                        :value="${x => x.avatarName}"
                        @input="${(x, c) => x.handleSearchInput('avatarName', c.event.target.value)}"
                        placeholder="${'reports.avatarNamePlaceholder'.t()}"
                    />
                </div>
                ${(0, fast_element_1.when)(x => x.isSuperAdmin, (0, fast_element_1.html) `<div class="col-md-2">
                    <label class="form-label">${'reports.companyName'.t()}</label>
                    <input 
                        type="text" 
                        class="form-control" 
                        :value="${x => x.companyName}"
                        @input="${(x, c) => x.handleSearchInput('companyName', c.event.target.value)}"
                        placeholder="${'reports.companyNamePlaceholder'.t()}"
                    />
                </div>`)}
                <div class="col-md-2">
                    <label class="form-label">&nbsp;</label>
                    <div class="d-flex gap-2">
                        <button type="button" class="btn btn-primary mr-1" @click="${x => x.applyFilters()}">
                            ${'common.apply'.t()}
                        </button>
                        <button type="button" class="btn btn-secondary" @click="${x => x.clearFilters()}">
                            ${'common.clear'.t()}
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>

    
    <div class="stats-cards" ?hidden="${x => !x.stats}">
        <div class="row">
            <div class="col-lg-2 col-md-4 col-sm-6">
                <div class="card stat-card">
                    <div class="card-body">
                        <h5 class="card-title">${'reports.totalCost'.t()}</h5>
                        <h3 class="stat-value text-primary">${x => { var _a; return x.formatCurrency(((_a = x.stats) === null || _a === void 0 ? void 0 : _a.totalCost) || 0); }}</h3>
                    </div>
                </div>
            </div>
            <div class="col-lg-2 col-md-4 col-sm-6">
                <div class="card stat-card">
                    <div class="card-body">
                        <h5 class="card-title">${'reports.totalTokens'.t()}</h5>
                        <h3 class="stat-value text-info">${x => { var _a; return x.formatNumber(((_a = x.stats) === null || _a === void 0 ? void 0 : _a.totalTokens) || 0); }}</h3>
                    </div>
                </div>
            </div>
            <div class="col-lg-2 col-md-4 col-sm-6">
                <div class="card stat-card">
                    <div class="card-body">
                        <h5 class="card-title">${'reports.totalMessages'.t()}</h5>
                        <h3 class="stat-value text-success">${x => { var _a; return x.formatNumber(((_a = x.stats) === null || _a === void 0 ? void 0 : _a.totalMessages) || 0); }}</h3>
                    </div>
                </div>
            </div>
            <div class="col-lg-2 col-md-4 col-sm-6">
                <div class="card stat-card">
                    <div class="card-body">
                        <h5 class="card-title">${'reports.avgCostPerMessage'.t()}</h5>
                        <h3 class="stat-value text-warning">${x => { var _a; return x.formatCurrency(((_a = x.stats) === null || _a === void 0 ? void 0 : _a.averageCostPerMessage) || 0); }}</h3>
                    </div>
                </div>
            </div>
            <div class="col-lg-2 col-md-4 col-sm-6">
                <div class="card stat-card">
                    <div class="card-body">
                        <h5 class="card-title">${'avatar.avatar'.t()} ${'reports.messageCount'.t()}</h5>
                        <h3 class="stat-value text-purple">${x => { var _a; return x.formatNumber((((_a = x.stats) === null || _a === void 0 ? void 0 : _a.topAvatars) || []).reduce((sum, a) => sum + a.messageCount, 0)); }}</h3>
                    </div>
                </div>
            </div>
            <div class="col-lg-2 col-md-4 col-sm-6">
                <div class="card stat-card">
                    <div class="card-body">
                        <h5 class="card-title">Top ${'avatar.avatar'.t()}</h5>
                        <h3 class="stat-value text-dark">${x => { var _a, _b; return ((_b = (((_a = x.stats) === null || _a === void 0 ? void 0 : _a.topAvatars) || [])[0]) === null || _b === void 0 ? void 0 : _b.avatarName) || '-'; }}</h3>
                    </div>
                </div>
            </div>
        </div>
    </div>

    
    <div class="card chart-card" ?hidden="${x => !x.stats || !x.showChart}">
        <div class="card-header d-flex justify-content-between align-items-center">
            <h5 class="mb-0">${'reports.costTrends'.t()}</h5>
            <button type="button" class="btn btn-sm btn-outline-secondary" @click="${x => x.toggleChart()}">
                <i class="bi bi-eye-slash"></i> ${'common.hide'.t()}
            </button>
        </div>
        <div class="card-body">
            <canvas id="costChart" width="400" height="200"></canvas>
        </div>
    </div>

    
    <div class="text-center mb-3" ?hidden="${x => !x.stats || x.showChart}">
        <button type="button" class="btn btn-outline-primary" @click="${x => x.toggleChart()}">
            <i class="bi bi-bar-chart"></i> ${'reports.showChart'.t()}
        </button>
    </div>    
    

    
    <div class="card data-table-card">
        <div class="card-header d-flex justify-content-between align-items-center">
            <h5 class="mb-0">${'report.usage_cost_data'.t()}</h5>
            <div class="table-info">
                ${x => x.totalCount} ${'common.results'.t()}
            </div>
        </div>
        <div class="card-body">
            <div class="table-responsive" ?hidden="${x => x.loading || x.data.length === 0}">
                <table class="table table-hover table-striped" style="${x => x.tableWidth ? `width: ${x.tableWidth}` : ''}">
                    <thead>
                        <tr>                      
                            <th class="col-actions text-center"></th>   
                            <th class="col-date">${'reports.date'.t()}</th>   
                            <th class="col-tokens">${'reports.promptTokens'.t()}</th>
                            <th class="col-tokens">${'reports.completionTokens'.t()}</th>
                            <th class="col-tokens">${'reports.totalTokens'.t()}</th>
                            <th class="col-cost">${'reports.cost'.t()}</th>                            
                            <th class="col-user">${'reports.user'.t()}</th>
                            <th class="col-avatar">${'avatar.avatar'.t()}</th>
                            <th class="col-model">${'avatar.model'.t()}</th>
                            <th class="col-tools">${'message.used_tools'.t()}</th>
                            <th class="col-cost-type">${'reports.cost_type'.t()}</th>
                            ${(0, fast_element_1.when)(x => x.isSuperAdmin, (0, fast_element_1.html) `<th class="col-company">${'reports.company'.t()}</th>`)}                                                       
                        </tr>
                    </thead>
                    <tbody>
                        ${(0, fast_element_1.repeat)(x => x.data || [], (0, fast_element_1.html) `
                            <tr>      
                                <td class="col-actions text-center">
                                    <rws-tooltip side="top" text="${'cost.preview.view_details'.t()}">
                                        <button @click="${(x, c) => c.parent.viewCostDetails(x)}" 
                                                class="btn btn-sm btn-info" 
                                                title="${'cost.preview.view_details'.t()}">
                                            <i class="simple-icon-magnifier"></i>
                                        </button>
                                    </rws-tooltip>
                                </td>                                             
                                <td class="col-date">${(x, c) => c.parent.formatDate(x.created_at)}</td>
                                <td class="col-tokens text-end">${(x, c) => c.parent.formatNumber(x.prompt_tokens)}</td>
                                <td class="col-tokens text-end">${(x, c) => c.parent.formatNumber(x.completion_tokens)}</td>
                                <td class="col-tokens text-end font-weight-bold">${(x, c) => c.parent.formatNumber(x.total_tokens)}</td>
                                <td class="col-cost text-end font-weight-bold text-primary">${(x, c) => c.parent.formatCurrency(x.cost)}</td>                                
                                <td class="col-user">${x => x.user_name || x.user || '-'}</td>
                                <td class="col-avatar">${x => x.avatar_name || '-'}</td>
                                <td class="col-model">${x => x.used_model}</td>
                                <td class="col-tools">${(x, c) => c.parent.formatTools(x.message_tools)}</td>
                                <td class="col-cost-type">${x => x.cost_type}</td>
                                ${(0, fast_element_1.when)(x => x.isSuperAdmin, (0, fast_element_1.html) `<td class="col-company">${x => x.company || '-'}</td>`)}                                            
                            </tr>
                        `)}
                    </tbody>
                </table>
            </div>

            
            <div class="text-center py-4" ?hidden="${x => !x.loading}">
                <app-loader></app-loader>
            </div>

            
            <div class="text-center py-4" ?hidden="${x => x.loading || x.data.length > 0}">
                <div class="empty-state">
                    <i class="bi bi-table fs-1 text-muted"></i>
                    <h5 class="mt-2 text-muted">${'reports.noData'.t()}</h5>
                    <p class="text-muted">${'reports.noDataDescription'.t()}</p>
                </div>
            </div>

            
            <app-pagination 
                ?hidden="${x => x.loading || x.data.length === 0}"
                :currentPage="${x => x.currentPage}"
                :totalPages="${x => x.totalPages}"
                :perPage="${x => x.perPage}"
                :totalItems="${x => x.totalCount}"
                :onPageChange="${x => x.handlePageChange.bind(x)}"
                size="sm">
            </app-pagination>
        </div>
    </div>

    
    <div class="card mt-4 data-table-card" ?hidden="${x => x.loading || x.userSummary.length === 0}">
         <div class="card-header d-flex justify-content-between align-items-center">
            <h5 class="mt-3">${'reports.userSummary'.t()}</h5>
        </div>
        <div class="card-body">
            <div class="table-responsive">
                <table class="table table-striped table-hover">
                    <thead>
                        <tr>
                            <th>${'reports.user'.t()}</th>                            
                            <th class="text-end">${'reports.totalCost'.t()}</th>
                            <th class="text-end">${'reports.totalTokens'.t()}</th>
                            <th class="text-end">${'reports.promptTokens'.t()}</th>
                            <th class="text-end">${'reports.completionTokens'.t()}</th>
                            <th class="text-end">${'reports.messageCount'.t()}</th>
                            <th class="text-end">${'reports.avgCostPerMessage'.t()}</th>
                            <th class="text-end">${'reports.avgTokensPerMessage'.t()}</th>                            
                        </tr>
                    </thead>
                    <tbody>
                        ${(0, fast_element_1.repeat)(x => x.userSummary, (0, fast_element_1.html) `
                            <tr>
                                <td><strong>${x => x.userDisplayName}</strong></td>
                                <td class="text-end font-weight-bold text-primary">${(x, c) => c.parent.formatCurrency(x.totalCost)}</td>
                                <td class="text-end font-weight-bold">${(x, c) => c.parent.formatNumber(x.totalTokens)}</td>
                                <td class="text-end">${(x, c) => c.parent.formatNumber(x.promptTokens)}</td>
                                <td class="text-end">${(x, c) => c.parent.formatNumber(x.completionTokens)}</td>
                                <td class="text-end">${(x, c) => c.parent.formatNumber(x.messageCount)}</td>
                                <td class="text-end">${(x, c) => c.parent.formatCurrency(x.averageCostPerMessage)}</td>
                                <td class="text-end">${(x, c) => c.parent.formatNumber(x.averageTokensPerMessage)}</td>                                
                            </tr>
                        `)}
                    </tbody>
                </table>
            </div>
        </div>
    </div>

    
    <div class="card mt-4 data-table-card" ?hidden="${x => x.loading || !x.avatarUsage || x.avatarUsage.length === 0}">
         <div class="card-header d-flex justify-content-between align-items-center">
            <h5 class="mt-3">${'reports.avatarUsage'.t()}</h5>
        </div>
        <div class="card-body">
            <div class="table-responsive">
                <table class="table table-striped table-hover">
                    <thead>
                        <tr>
                            <th>${'avatar.avatar'.t()}</th>                            
                            <th class="text-end">${'reports.totalCost'.t()}</th>
                            <th class="text-end">${'reports.totalTokens'.t()}</th>
                            <th class="text-end">${'reports.messageCount'.t()}</th>
                            <th class="text-end">${'reports.avgCostPerMessage'.t()}</th>                            
                        </tr>
                    </thead>
                    <tbody>
                        ${(0, fast_element_1.repeat)(x => x.avatarUsage || [], (0, fast_element_1.html) `
                            <tr>
                                <td><strong>${x => x.avatarName}</strong></td>
                                <td class="text-end font-weight-bold text-primary">${(x, c) => c.parent.formatCurrency(x.totalCost)}</td>
                                <td class="text-end font-weight-bold">${(x, c) => c.parent.formatNumber(x.totalTokens)}</td>
                                <td class="text-end">${(x, c) => c.parent.formatNumber(x.messageCount)}</td>
                                <td class="text-end">${(x, c) => c.parent.formatCurrency(x.averageCostPerMessage)}</td>                                
                            </tr>
                        `)}
                    </tbody>
                </table>
            </div>
        </div>
    </div>
    `)}
</div>
`;
require("./styles/layout.scss");
const styles = T.css `.cost-reports {
  padding: 1.5rem;
}
.cost-reports .page-header {
  margin-bottom: 2rem;
}
.cost-reports .page-header h2 {
  margin-bottom: 0.5rem;
  color: #2c3e50;
}
.cost-reports .page-header .text-muted {
  font-size: 1.1rem;
}
.cost-reports .stats-cards {
  margin-bottom: 2rem;
}
.cost-reports .stats-cards .row {
  margin: 0 -8px;
}
.cost-reports .stats-cards .col-lg-2,
.cost-reports .stats-cards .col-md-4,
.cost-reports .stats-cards .col-sm-6 {
  padding: 0 8px;
  margin-bottom: 16px;
}
.cost-reports .stats-cards .stat-card {
  border: none;
  border-radius: 10px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
  transition: transform 0.2s ease-in-out;
  height: 100%;
}
.cost-reports .stats-cards .stat-card:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15);
}
.cost-reports .stats-cards .stat-card .card-body {
  padding: 1.25rem;
  text-align: center;
}
.cost-reports .stats-cards .stat-card .card-title {
  font-size: 0.85rem;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  margin-bottom: 0.75rem;
  color: #6c757d;
}
.cost-reports .stats-cards .stat-card .stat-value {
  font-size: 1.5rem;
  font-weight: 700;
  margin: 0;
  line-height: 1.2;
}
.cost-reports .stats-cards .stat-card .stat-value.text-purple {
  color: #7b68ee !important;
}
.cost-reports .chart-card {
  border: none;
  border-radius: 10px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
  margin-bottom: 2rem;
}
.cost-reports .chart-card .card-header {
  background-color: #f8f9fa;
  border-bottom: 1px solid #e9ecef;
  border-radius: 10px 10px 0 0;
  padding: 1rem 1.5rem;
}
.cost-reports .chart-card .card-header h5 {
  color: #495057;
  font-weight: 600;
}
.cost-reports .chart-card .card-body {
  padding: 1.5rem;
}
.cost-reports .chart-card .card-body canvas {
  max-height: 400px;
}
.cost-reports .filters-card, .cost-reports .data-table-card {
  border: none;
  border-radius: 10px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
  margin-bottom: 2rem;
}
.cost-reports .filters-card .card-header, .cost-reports .data-table-card .card-header {
  background-color: #f8f9fa;
  border-bottom: 1px solid #e9ecef;
  border-radius: 10px 10px 0 0;
  padding: 1rem 1.5rem;
}
.cost-reports .filters-card .card-header h5, .cost-reports .data-table-card .card-header h5 {
  color: #495057;
  font-weight: 600;
}
.cost-reports .filters-card .card-body, .cost-reports .data-table-card .card-body {
  padding: 1.5rem;
}
.cost-reports .table-info {
  font-size: 0.9rem;
  color: #6c757d;
  font-weight: 500;
  padding: 5px;
  border-radius: 3px;
}
.cost-reports .empty-state {
  padding: 3rem 1rem;
}
.cost-reports .empty-state i {
  opacity: 0.3;
}
.cost-reports .empty-state h5 {
  margin-top: 1rem;
  margin-bottom: 0.5rem;
}
.cost-reports .empty-state p {
  margin-bottom: 0;
}
@media (max-width: 768px) {
  .cost-reports {
    padding: 1rem;
  }
  .cost-reports .stats-cards .col-md-3 {
    margin-bottom: 1rem;
  }
  .cost-reports .filters-card .row .col-md-2 {
    margin-bottom: 1rem;
  }
  .cost-reports .d-flex.justify-content-between {
    flex-direction: column;
    gap: 1rem;
  }
}

.spinner-border {
  width: 3rem;
  height: 3rem;
  border-width: 0.3em;
}

.table thead th {
  vertical-align: middle;
}
.table .col-date {
  width: 180px;
  min-width: 180px;
}
.table .col-tokens {
  width: 100px;
  min-width: 100px;
}
.table .col-cost {
  width: 120px;
  min-width: 120px;
}
.table .col-user {
  width: 140px;
  min-width: 140px;
}
.table .col-avatar {
  width: 140px;
  min-width: 140px;
}
.table .col-model {
  width: 120px;
  min-width: 120px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.table .col-tools {
  width: 150px;
  min-width: 150px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.table .col-cost-type {
  width: 80px;
  min-width: 80px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.table .col-company {
  width: 140px;
  min-width: 140px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.table .col-actions {
  width: 80px;
  min-width: 80px;
}`;
const shadowOptions = { "mode": "open" };
let CostReports = class CostReports extends client_1.RWSViewComponent {
    constructor(storageService) {
        super();
        this.storageService = storageService;
        this.loading = false;
        this.data = [];
        this.stats = null;
        this.userSummary = [];
        this.avatarUsage = null;
        this.currentPage = 1;
        this.totalPages = 1;
        this.perPage = 20;
        this.totalCount = 0;
        // Chart properties
        this.chartInstance = null;
        this.showChart = true;
        // Filters
        this.startDate = '';
        this.endDate = '';
        this.selectedUserId = '';
        this.companyName = '';
        this.userName = '';
        this.avatarName = '';
        // Search debouncing
        this.searchTimeout = null;
        this.isSuperAdmin = false;
        this.hasAccess = true;
        this.accessDeniedMessage = '';
        this.tableWidth = '';
    }
    async connectedCallback() {
        // Check user authorization first
        this.checkAccess();
        if (!this.hasAccess) {
            super.connectedCallback();
            return;
        }
        // Load saved chart visibility state from localStorage
        // Set default date range (last 30 days)
        const endDate = new Date();
        const startDate = new Date();
        startDate.setDate(endDate.getDate() - 30);
        this.endDate = endDate.toISOString().split('T')[0];
        this.startDate = startDate.toISOString().split('T')[0];
        await this.loadData();
        await this.loadUserSummary();
        await this.loadAvatarUsage();
        if (component_1.DefaultLayout.USER.role === backendImport_1.UserRoles.SUPER_ADMIN) {
            this.isSuperAdmin = true;
        }
        super.connectedCallback();
        const savedShowChart = this.storageService.get('reports.cost.showChart');
        if (savedShowChart !== null) {
            this.showChart = savedShowChart === 'true';
        }
        await this.loadStats();
    }
    checkAccess() {
        const user = component_1.DefaultLayout.USER;
        if (!user) {
            this.hasAccess = false;
            this.accessDeniedMessage = 'User not authenticated';
            return;
        }
        // Allow parent users, enterprise users, and super admins
        if (user.role !== backendImport_1.UserRoles.PARENT_USER && user.role !== backendImport_1.UserRoles.SUPER_ADMIN && user.role !== backendImport_1.UserRoles.ENTERPRISE) {
            this.hasAccess = false;
            this.accessDeniedMessage = 'reports.access.denied.general'.t();
            return;
        }
        this.hasAccess = true;
    }
    async loadData() {
        this.loading = true;
        try {
            const queryParams = {
                page: this.currentPage.toString(),
                limit: this.perPage.toString()
            };
            if (this.startDate)
                queryParams.startDate = this.startDate;
            if (this.endDate)
                queryParams.endDate = this.endDate;
            if (this.selectedUserId)
                queryParams.userId = this.selectedUserId;
            if (this.companyName)
                queryParams.companyName = this.companyName;
            if (this.userName)
                queryParams.userName = this.userName;
            if (this.avatarName)
                queryParams.avatarName = this.avatarName;
            const response = await this.apiService.back.get('reports.cost_report', { queryParams });
            if (response && response.success && Array.isArray(response.data)) {
                this.data = response.data;
                this.totalCount = response.total;
                this.totalPages = response.totalPages;
                // Don't update currentPage here as it should already be set correctly
                // this.currentPage = response.page;
            }
            else {
                this.notifyService.notify((response === null || response === void 0 ? void 0 : response.error) || 'reports.failedToLoad'.t(), 'error');
            }
        }
        catch (error) {
            console.error(error);
            this.notifyService.notify('reports.failedToLoad'.t(), 'error');
        }
        finally {
            this.loading = false;
        }
    }
    async loadStats() {
        try {
            const queryParams = {};
            if (this.startDate)
                queryParams.startDate = this.startDate;
            if (this.endDate)
                queryParams.endDate = this.endDate;
            if (this.companyName)
                queryParams.companyName = this.companyName;
            if (this.userName)
                queryParams.userName = this.userName;
            if (this.avatarName)
                queryParams.avatarName = this.avatarName;
            const response = await this.apiService.back.get('reports.usage_cost_stats', { queryParams });
            if (response && response.success && response.data) {
                this.stats = response.data;
                this.updateChart();
            }
        }
        catch (error) {
            console.error('Error loading stats:', error);
        }
    }
    async loadUserSummary() {
        try {
            const queryParams = {};
            if (this.startDate)
                queryParams.startDate = this.startDate;
            if (this.endDate)
                queryParams.endDate = this.endDate;
            if (this.companyName)
                queryParams.companyName = this.companyName;
            if (this.userName)
                queryParams.userName = this.userName;
            if (this.avatarName)
                queryParams.avatarName = this.avatarName;
            const response = await this.apiService.back.get('reports.user_summary_stats', { queryParams });
            if (response && response.success && Array.isArray(response.data)) {
                this.userSummary = response.data;
            }
        }
        catch (error) {
            console.error('Error loading user summary:', error);
        }
    }
    async loadAvatarUsage() {
        try {
            const queryParams = {};
            if (this.startDate)
                queryParams.startDate = this.startDate;
            if (this.endDate)
                queryParams.endDate = this.endDate;
            if (this.companyName)
                queryParams.companyName = this.companyName;
            if (this.userName)
                queryParams.userName = this.userName;
            if (this.avatarName)
                queryParams.avatarName = this.avatarName;
            const response = await this.apiService.back.get('reports.avatar_usage_stats', { queryParams });
            if (response && response.success && Array.isArray(response.data)) {
                this.avatarUsage = response.data;
            }
        }
        catch (error) {
            console.error('Error loading avatar usage:', error);
        }
    }
    async updateChart() {
        var _a;
        if (!this.stats || !this.stats.costByDate)
            return;
        // Destroy existing chart if it exists
        if (this.chartInstance) {
            this.chartInstance.destroy();
        }
        // Get canvas element
        const canvas = (_a = this.shadowRoot) === null || _a === void 0 ? void 0 : _a.querySelector('#costChart');
        if (!canvas)
            return;
        const ctx = canvas.getContext('2d');
        if (!ctx)
            return;
        // Prepare chart data
        const labels = this.stats.costByDate.map(item => item.date);
        const costData = this.stats.costByDate.map(item => item.cost);
        const tokensData = this.stats.costByDate.map(item => item.tokens);
        const config = {
            type: 'line',
            data: {
                labels: labels,
                datasets: [{
                        label: 'reports.cost'.t(),
                        data: costData,
                        borderColor: 'rgb(75, 192, 192)',
                        backgroundColor: 'rgba(75, 192, 192, 0.2)',
                        yAxisID: 'y'
                    }, {
                        label: 'reports.tokens'.t(),
                        data: tokensData,
                        borderColor: 'rgb(255, 99, 132)',
                        backgroundColor: 'rgba(255, 99, 132, 0.2)',
                        yAxisID: 'y1'
                    }]
            },
            options: {
                responsive: true,
                interaction: {
                    mode: 'index',
                    intersect: false,
                },
                scales: {
                    x: {
                        display: true,
                        title: {
                            display: true,
                            text: 'reports.date'.t()
                        }
                    },
                    y: {
                        type: 'linear',
                        display: true,
                        position: 'left',
                        title: {
                            display: true,
                            text: 'reports.cost'.t()
                        }
                    },
                    y1: {
                        type: 'linear',
                        display: true,
                        position: 'right',
                        title: {
                            display: true,
                            text: 'reports.tokens'.t()
                        },
                        grid: {
                            drawOnChartArea: false,
                        },
                    }
                }
            }
        };
        this.chartInstance = new chart_js_1.Chart(ctx, config);
    }
    async applyFilters() {
        this.currentPage = 1;
        await this.loadData();
        await this.loadStats();
        await this.loadUserSummary();
        await this.loadAvatarUsage();
    }
    async clearFilters() {
        this.startDate = '';
        this.endDate = '';
        this.selectedUserId = '';
        this.companyName = '';
        this.userName = '';
        this.avatarName = '';
        this.currentPage = 1;
        await this.loadData();
        await this.loadStats();
        await this.loadUserSummary();
        await this.loadAvatarUsage();
    }
    async handlePageChange(page) {
        if (page >= 1 && page <= this.totalPages) {
            this.currentPage = page;
            await this.loadData();
        }
    }
    toggleChart() {
        this.showChart = !this.showChart;
        // Save chart visibility state to localStorage
        this.storageService.set('reports.cost.showChart', this.showChart.toString());
        if (this.showChart) {
            // Delay chart update to ensure canvas is rendered
            setTimeout(() => this.updateChart(), 100);
        }
    }
    formatCurrency(amount) {
        return new Intl.NumberFormat('en-US', {
            style: 'currency',
            currency: 'USD',
            minimumFractionDigits: 5
        }).format(amount);
    }
    formatNumber(num) {
        return new Intl.NumberFormat('en-US').format(num);
    }
    formatDate(date) {
        const dateObj = new console_1.DateUtils(date);
        return dateObj.format('dd-MM-yyyy HH:mm');
    }
    formatTools(tools) {
        console.log({ tools });
        if (tools && tools.length > 0) {
            return tools.map(tool => `tools.${tool.toolName || tool.name}.name`.t()).join(', ');
        }
        return '-';
    }
    handleSearchInput(field, value) {
        // Clear previous timeout
        if (this.searchTimeout) {
            clearTimeout(this.searchTimeout);
        }
        // Update the field value
        this[field] = value;
        // Set debounced search with 500ms delay
        this.searchTimeout = setTimeout(() => {
            this.applyFilters();
        }, 500);
    }
    viewCostDetails(costEntry) {
        if (costEntry.id) {
            component_2.SiteMenu.goto.bind(this)(`/reports/cost/preview/${costEntry.id}`);
        }
    }
    disconnectedCallback() {
        super.disconnectedCallback();
        if (this.chartInstance) {
            this.chartInstance.destroy();
        }
        if (this.searchTimeout) {
            clearTimeout(this.searchTimeout);
        }
    }
};
exports.CostReports = CostReports;
__decorate([
    client_1.observable,
    __metadata("design:type", Boolean)
], CostReports.prototype, "loading", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", Array)
], CostReports.prototype, "data", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", Object)
], CostReports.prototype, "stats", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", Array)
], CostReports.prototype, "userSummary", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", Object)
], CostReports.prototype, "avatarUsage", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", Number)
], CostReports.prototype, "currentPage", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", Number)
], CostReports.prototype, "totalPages", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", Number)
], CostReports.prototype, "perPage", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", Number)
], CostReports.prototype, "totalCount", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", typeof (_b = typeof chart_js_1.Chart !== "undefined" && chart_js_1.Chart) === "function" ? _b : Object)
], CostReports.prototype, "chartInstance", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", Boolean)
], CostReports.prototype, "showChart", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", String)
], CostReports.prototype, "startDate", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", String)
], CostReports.prototype, "endDate", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", String)
], CostReports.prototype, "selectedUserId", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", String)
], CostReports.prototype, "companyName", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", String)
], CostReports.prototype, "userName", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", String)
], CostReports.prototype, "avatarName", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", Boolean)
], CostReports.prototype, "isSuperAdmin", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", Boolean)
], CostReports.prototype, "hasAccess", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", String)
], CostReports.prototype, "accessDeniedMessage", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", String)
], CostReports.prototype, "tableWidth", void 0);
exports.CostReports = CostReports = __decorate([
    (0, client_1.RWSView)('cost-reports', null, { template: rwsTemplate, styles, options: { shadowOptions } }),
    __param(0, (0, client_1.RWSInject)(StorageService_1.default)),
    __metadata("design:paramtypes", [typeof (_a = typeof StorageService_1.StorageServiceInstance !== "undefined" && StorageService_1.StorageServiceInstance) === "function" ? _a : Object])
], CostReports);
CostReports.defineComponent();
